import React from 'react';
import Toast from 'react-bootstrap/Toast';

import { Props } from './ForcedLogoutToastModel';
import { ERROR_MSG } from '../../errorHandler/errorBoundaryConstant';

const style = {
  position: 'fixed',
  top: 0,
  right: 0,
  minWidth: 270,
} as React.CSSProperties;

export default function ForcedLogoutToast(props: Props) {
  return (
    <Toast
      show={true}
      delay={6000}
      autohide
      onClose={props.onClose}
      animation
      style={style}
      className="notification-wrapper"
    >
      <Toast.Header>
        <span className="d-block">SINGLE LOGIN ENABLED</span>
      </Toast.Header>
      <Toast.Body style={{ whiteSpace: 'pre-line' }}>{ERROR_MSG.singleLogin}</Toast.Body>
    </Toast>
  );
}
